import { ProcesoConstructivo, UnidadObra } from '../../../../../../types/ObraDetails';

export interface ConstructionUnitOption { id: number; code: string; name: string }

export function replacementUnits(
  current: UnidadObra[], incoming: ConstructionUnitOption[], excluded: Set<string>
): UnidadObra[] {
  const previous = new Map(current.map((unit) => [unit.unidad?.codUnidad, unit]));
  return [...new Map(incoming.filter((unit) => !excluded.has(unit.code)).map((unit) => [unit.code, {
    ...previous.get(unit.code),
    unidad: { id: unit.id, codUnidad: unit.code, nomUnidad: unit.name },
  }])).values()];
}

export function losesMeasurements(current: UnidadObra[], next: UnidadObra[]): boolean {
  const retained = new Set(next.map((unit) => unit.unidad?.codUnidad));
  return current.some((unit) => unit.medicion !== undefined && unit.medicion !== null
    && !retained.has(unit.unidad?.codUnidad));
}

export const sameSelection = (left: ProcesoConstructivo, right: ProcesoConstructivo): boolean =>
  left.capitulo?.codigo === right.capitulo?.codigo && left.codigo === right.codigo
  && left.procesoConstructivo?.codigo === right.procesoConstructivo?.codigo;
